/* eslint-disable @typescript-eslint/naming-convention */
import { ClinicalAssessmentTypes } from '@sondermind/utilities/models-assessments-monolith';
import { InPersonWorkingHoursFeatureFlag } from '@sondermind/utilities/models-availability';
import { FeatureFlagKey } from './feature-flag-key.enum';
import { FeatureFlagDefaults } from './feature-flag-types';

/**
 * Feature flag values used in CI environment.
 * Add new flag values here as needed for e2e tests.
 */
export const FEATURE_FLAG_CI_VALUES: FeatureFlagDefaults = {
  // String flags
  [FeatureFlagKey.IN_PERSON_WORKING_HOURS]: InPersonWorkingHoursFeatureFlag.LEGACY_VIEW,

  // Boolean flags
  [FeatureFlagKey.DIRECT_SCHEDULE_ANY_MATCH]: false,
  [FeatureFlagKey.OPTIMIZE_ANALYTICS_DASH]: false,
  [FeatureFlagKey.USE_TREATMENT_PLAN_SHARING]: false,
  [FeatureFlagKey.QUICK_CHECKOUT_AUTH0]: false,
  [FeatureFlagKey.QUICK_CHECKOUT_SIGN_IN_TO_BOOK]: false,
  [FeatureFlagKey.PSYCHIATRY_FLOW_AUTH0]: false,
  [FeatureFlagKey.AUTOMATED_CONSENT_DOCS]: false,
  [FeatureFlagKey.ALLOW_BULK_UPLOAD_CLIENTS]: false,
  [FeatureFlagKey.DIRECTORY_HOMEPAGE_REDESIGN]: false,
  [FeatureFlagKey.NEW_DIRECTORY_HOMEPAGE_FILTERS]: false,
  [FeatureFlagKey.PUBLIC_DIRECTORY_ZIP_RADIUS_IN_PERSON_SEARCH]: false,
  [FeatureFlagKey.PROVIDER_CANCELLATION_REASONS]: false,
  [FeatureFlagKey.SHOW_CLIENT_JOURNEY_V2]: false,
  [FeatureFlagKey.CLIENT_GOALS]: false,
  [FeatureFlagKey.FORCE_ACCOUNT_COMPLETION_BOOKING]: false,
  [FeatureFlagKey.FORCE_ACCOUNT_COMPLETION_BEFORE_CHAT]: false,
  [FeatureFlagKey.DEPRECATE_FUNCTIONAL_CQ]: false,
  [FeatureFlagKey.APP_DOWNLOAD_BANNER]: false,
  [FeatureFlagKey.BILLING_TRANSPARENCY]: false,
  [FeatureFlagKey.CLIENT_CHAT_REQUIRE_VERIFICATION]: false,
  [FeatureFlagKey.VA_RFS_ENABLED]: false,
  [FeatureFlagKey.RESUME_RECORDING_ON_RECONNECT]: false,
  [FeatureFlagKey.WORKSHEETS_NAV]: true,

  // Structured flags (JSON payloads)
  [FeatureFlagKey.DISPLAY_FILE_UPLOAD_HISTORY]: {
    displayInClientPortal: false,
    displayInProviderPortal: false
  },
  [FeatureFlagKey.IN_SESSION_SCHEDULING_PROMPT]: {
    title: 'Schedule your next visit',
    bodyText:
      'You don\'t have any more sessions with {clientName}. ' +
      'Schedule your next visit with them before you wrap up.'
  },
  [FeatureFlagKey.NEW_CQS]: {
    'active-cqs': [
      ClinicalAssessmentTypes.CSSRS_ADULTS,
      ClinicalAssessmentTypes.PROMIS_ANGER,
      ClinicalAssessmentTypes.PROMIS_ANXIETY,
      ClinicalAssessmentTypes.PROMIS_DEPRESSION,
      ClinicalAssessmentTypes.AUDIT_C,
      ClinicalAssessmentTypes.S2BI,
      ClinicalAssessmentTypes.CSSRS_KIDS,
      ClinicalAssessmentTypes.ASRS_A,
      ClinicalAssessmentTypes.ASRS_AB,
      ClinicalAssessmentTypes.WHO_5
    ],
    'show-date-administered': false
  },
  [FeatureFlagKey.SCHEDULING_CTA_THEME]: {
    placement: 'front'
  }
};
